<template>
  <div class="stars">
    <svg
      v-for="i of value"
      :key="i"
      class="stars__item"
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16.7369 5.89661L11.7779 5.17591L9.5611 0.68177C9.50056 0.558723 9.40095 0.459114 9.2779 0.398567C8.96931 0.246223 8.59431 0.373176 8.44001 0.68177L6.22321 5.17591L1.26423 5.89661C1.12751 5.91615 1.00251 5.9806 0.906805 6.07825C0.791106 6.19717 0.72735 6.35716 0.729547 6.52306C0.731745 6.68896 0.799715 6.84721 0.918524 6.96302L4.50642 10.4611L3.65876 15.4005C3.63888 15.5154 3.6516 15.6336 3.69546 15.7416C3.73933 15.8497 3.81259 15.9433 3.90694 16.0118C4.00129 16.0803 4.11295 16.121 4.22927 16.1293C4.34558 16.1376 4.46189 16.1132 4.56501 16.0587L9.00056 13.7267L13.4361 16.0587C13.5572 16.1232 13.6978 16.1447 13.8326 16.1212C14.1724 16.0626 14.4009 15.7404 14.3424 15.4005L13.4947 10.4611L17.0826 6.96302C17.1802 6.86732 17.2447 6.74232 17.2642 6.6056C17.317 6.2638 17.0787 5.9474 16.7369 5.89661Z" fill="#FFCF55"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'BaseStars',
  props: {
    value: {
      type: Number,
      default: 5
    }
  }
}
</script>

<style lang="scss" scoped>
.stars {
  &__item {
    &:not(:last-child) {
      margin-right: 4px;
    }
  }
}
</style>
